import React from 'react'
import { Link } from 'react-router'
import { Glyphicon, Panel, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

import Button from "../components/Button"
import { requestPasswordReset } from '../lib/APIClient.js'
import { getText } from '../lib/text'

const styles = {
  panel: { margin : "40px" },
  button: { display: "block", marginTop: 5, marginRight: 10 },
  inputGroup: { marginBottom: "20px", marginTop: 20 }, 
  input: { maxWidth: "200px", marginBottom: 20 }
}

class RequestPasswordReset extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = { 
      username: (this.props.routeParams && this.props.routeParams.username) || "", 
      sent: false, 
      done: false, 
      errorMessage: null, 
    }

    this.boundRequestResetEmail = this.requestReset.bind(this, "email")
    this.boundRequestResetSlack = this.requestReset.bind(this, "slack")
  }
  
  requestReset(via) {
    this.setState({ sent: true, errorMessage: null })
    
    requestPasswordReset(
      this.state.username, 
      (e, body) => {
        if (e) {
          console.log(`requestreset error!: ${e}`)
          this.setState({ errorMessage: e.msg || getText("Error desconocido"), sent: false })
        }
        else {
          console.log(`requestreset success, done!`)
          this.setState({ done: true })
        }
      }, 
      via
    ) 
  }

  render() {
    return (
      <Panel style={styles.panel}>
        <Panel.Body>

          <Link to="/login" style={{fontWeight: "bold", fontSize: "15px"}}>
            {getText("Volver al login")}
          </Link>
          
          <FormGroup controlId="login-name">
            <ControlLabel>{getText("Nombre")}</ControlLabel>
            <FormControl 
              type="text" 
              name="username" 
              style={styles.input}
              value={this.state.username}
              onChange={evt => this.setState({ username: evt.target.value, errorMessage: null })}
              disabled={this.state.sent}
            />
          </FormGroup>
          
          { 
            this.state.errorMessage && (
              <span style={{color: "red", fontWeight: "bold"}}>
                <Glyphicon glyph="warning-sign" />{" "}
                {this.state.errorMessage}
                <br />
              </span>
            )
          }

          {
            this.state.done ? (
              <span style={{color: "green", fontWeight: "bold"}}>
                <Glyphicon glyph="ok" />{" "}
                {getText("reset_pwd_ok")}
                <br />
              </span>
            ) : ""
          }

          <Button 
            style={styles.button}
            onClick={this.boundRequestResetSlack}
            disabled={this.state.sent}
            glyph={ this.state.sent ? "retweet" : "comment" } 
          >
            {getText("Recibir enlace por Slack")}
          </Button>

          <Button 
            style={styles.button}
            onClick={this.boundRequestResetEmail}
            disabled={this.state.sent}
            glyph={ this.state.sent ? "retweet" : "envelope" } 
            bsSize="xs"
          >
            {getText("Recibir enlace por email")}
          </Button>

        </Panel.Body>   
      </Panel>
    )
  }
}

export default RequestPasswordReset
